import React from 'react';
import LabelEventGraph from './LabelEventGraph';

const LabelEventGraphGeo = (props) => <LabelEventGraph {...props} geoMode={true} />;

export default LabelEventGraphGeo;
